import * as API from "../../api"
import * as ActionTypes from "../action-types";
import { REDUX } from '../../../constants'

/**
 * ThirdParty Library
 */
 import {
    message
} from 'antd'

/**
 * Redux Action
 */
import { 
    get_vehicle_request,
    get_vehicles_request
} from './vehicles'
// import {
//     get_vehicle_maintenance_profiles_request,
//     get_vehicle_maintenance_states_request
// } from './vehicleMaintenances'
// import {
//     get_vam_entry_thru_vid_request
// } from './vamEntries'

import { 
    setLoadingVehicle,
    unsetLoadingVehicle,
    setLoadingGeneral,
    unsetLoadingGeneral
} from './style'

/**
 * Get Vehicle Group
 */

export const get_vehicle_group_request = (vhcgid, uid = null) => dispatch => {

    dispatch(setLoadingGeneral())

    API
    .getVehicleGroupByVHCGID(vhcgid)
    .then(info => {
        
        try {
            const {
                vehicleGroup
            } = info

            dispatch(get_vehicle_group_success(vehicleGroup, uid))
            vehicleGroup && vehicleGroup.vehicles && dispatch(get_vehicle_request(vehicleGroup.vehicle, uid))


        } catch(err) {
            message.error('Error in getting vehicle groups. Refresh page?')
        }

    }).finally(() => { dispatch(unsetLoadingGeneral())})
}

const get_vehicle_group_success = (vehicleGroup, uid = null) => {
    return {
        type: ActionTypes.GET_VEHICLE_GROUP,
        vehicleGroup,
        uid
    };
}

/**
 * Get Vehicle Groups
 */

//  export const get_vehicle_groups_request = (vhcgids, uid = null) => dispatch => {

//     let vgidBatch = []

//     vhcgids.map((vhcgid, index) => {

//         vgidBatch.push(vhcgid)

//         if( 
//             (index+1) % REDUX.REDUX_VEHICLE_GROUP_BATCH_GET_SIZE === 0
//             ||
//             index+1 === vhcgids.length
//         ) {
//             // setTimeout(() => dispatch(batch_get_vehicle_groups_request(vgidBatch, uid)), 100)
//             dispatch(batch_get_vehicle_groups_request(vgidBatch, uid))
//             vgidBatch = []
//         }

//         return null
//     })
//  }

// Ubah jadi async function
export const get_vehicle_groups_request = (drvgids, uid = null) => async dispatch => {
    
    // 1. Bikin batch-batch dulu
    const batches = [];
    let currentBatch = [];
    
    drvgids.forEach((drvgid, index) => {
        currentBatch.push(drvgid);
        
        if (
            (index + 1) % REDUX.REDUX_DEVICE_GROUP_BATCH_GET_SIZE === 0 ||
            index + 1 === drvgids.length
        ) {
            batches.push([...currentBatch]); // Simpan batch
            currentBatch = [];
        }
    });
    
    // 2. Proses sequential: 1 batch selesai → lanjut batch berikutnya
    for (let i = 0; i < batches.length; i++) {
        const batch = batches[i];
        
        // TUNGGU sampe batch ini selesai
        await dispatch(batch_get_vehicle_groups_request(batch, uid));
        
        // Jeda opsional
        await delay(500); // 500ms antar batch
    }
};

// Helper delay
const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

/**
 * Batch Get Vehicle Groups
 */
 export const batch_get_vehicle_groups_request = (vhcgids, uid = null) => dispatch => {
     dispatch(setLoadingVehicle())

    API
    .getVehicleGroupBatch(vhcgids) 
    .then(info => {
        
        try {
            const {
                vehicleGroups
            } = info

            dispatch(batch_get_vehicle_groups_success(vehicleGroups, uid))

            const vids = vehicleGroups && vehicleGroups.reduce((acc, cur) => [...acc, ...cur.vehicles], []) || []

            if(
                vids
                &&
                vids.length
            ) {
                setTimeout(() => dispatch(get_vehicles_request(vids, uid)), 0)

                // vids.map(vid => dispatch(get_vam_entry_thru_vid_request(vid)))
                // const vids = [...new Set(vehicleGroups.flatMap(vg => vg.vehicles))];

                // dispatch(get_vehicle_maintenance_profiles_request(vids)) 
                // dispatch(get_vehicle_maintenance_states_request(vids))  
                dispatch(get_vehicles_by_vehicle_group_relation_success(vids, vhcgids, uid))

            }

        } catch(err) {
            message.error('Error in batch getting vehicle groups. Refresh page?')
        }

    }).finally(() => {
        dispatch(unsetLoadingVehicle())
    })
}

const batch_get_vehicle_groups_success = (vehicleGroups, uid = null) => {
    return {
        type: ActionTypes.GET_VEHICLE_GROUPS,
        vehicleGroups,
        uid
    };
}


export const create_vehicle_group_request = (items, cb = () => {}) => dispatch => {

    API
    .createVehicleGroup(items)
    .then(info => {
        const { status, vehicleGroup, msg } = info

        if(status === 200) {
            dispatch(create_vehicle_group_success(vehicleGroup))
            message.success(msg)
            cb(vehicleGroup.vhcgid)
        } else {
            message.warning('Failed in create new vehicle group. Retry?')
        }
    })

}

const create_vehicle_group_success = (vehicleGroup) => {
    return {
        type: ActionTypes.CREATE_VEHICLE_GROUP,
        vehicleGroup
    }
}

export const update_vehicle_group_request = (items, cb = () => {}) => dispatch => {

    API
    .updateVehicleGroup(items)
    .then(info => {
        const { status, vehicleGroup, msg } = info

        if(status === 200) {
            dispatch(update_vehicle_group_success(vehicleGroup))
            message.success(msg)
            cb(items.vhcgid)
        } else {
            message.warning('Failed in updating vehicle group. Retry?')
        }
    })

}

const update_vehicle_group_success = (vehicleGroup) => {
    return {
        type: ActionTypes.UPDATE_VEHICLE_GROUP,
        vehicleGroup
    }
}

export const get_vehicles_by_vehicle_group_relation_request = (vhcgids, uid = null) => dispatch => {
    API
    .getVehicleGroupBatch(vhcgids) 
    .then(info => {
        
            const {
                vehicleGroups = []
            } = info

            const vids = [...new Set(vehicleGroups.flatMap(vg => vg.vehicles))];

            dispatch(get_vehicles_by_vehicle_group_relation_success(vids, vhcgids, uid))

        })
    }

const get_vehicles_by_vehicle_group_relation_success = (vids, vhcgids, uid = null) => {
        return {
            type: ActionTypes.GET_VEHICLES_BY_VEHICLE_GROUP_RELATION,
            vids,
            vhcgids,
            uid
        }
    }

export const add_vehicle_group_by_vid_success = (vids, vhcgids, uid) => {
    return {
        type: ActionTypes.ADD_VEHICLE_GROUP_BY_VID,
        vids, vhcgids, uid
    }
}

export const unassign_vehicle_from_group_request = (vids, vhcgid) => dispatch => {

    API.
    unassignVehicleFromGroup({
        vids,
        vhcgid
    })
    .then(info => {

        const { status, msg, vehicleGroup, vehicles } = info

        if(status === 200) {
            dispatch(unassign_vehicle_from_group_success({ ...vehicleGroup, vehicles }))
            message.success('Vehicle unassigned Successfully')
        } else {
            message.warning('Failed in removing vehicle from vehicle group. Retry? Error: ' + msg)
        }
    })
}

const unassign_vehicle_from_group_success = (vehicleGroup) => {
    return {
        type: ActionTypes.UNASSIGN_VEHICLE_FROM_GROUP,
        vehicleGroup
    }
}